import React from 'react'

export const currency_icon = (currency_code, css_class) => {
  const path = require(`assets/images/currency-icons/${currency_code}.svg`)
  return <img src={path} className={css_class} alt={currency_code} />
}

const prepare_number = (value_raw, round_num) => {
  var value = String(value_raw).replace(/[^0-9|/.]/g, '')

  if (/^\./.test(value)) {
    value = value.replace(/[^0-9]/g, '')
  }
  if (/^0/.test(value) && !/^0\./.test(value)) {
    value = value.substr(1)
  }

  if (typeof round_num !== 'undefined' && value.indexOf('.') !== -1) {
    value = value.substr(0, value.indexOf('.') + round_num + (round_num === 0 ? 0 : 1))
  }
  if (value.length === 0) return 0
  return value
}

export const prepare_coin_number = parameters => value_raw => {
  return prepare_number(value_raw, parameters['coin.precision'])
}

export const prepare_currency_number = parameters => (value_raw, currency) => {
  const round_num =
    currency === parameters['coin.rate_currency']
      ? parameters['coin.usd_precision']
      : parameters['coin.currency_precision']
  return prepare_number(value_raw, round_num)
}



// WEBPACK FOOTER //
// ./src/core/utils/index.js